export default "__VITE_ASSET__BdYjIqGY__"